interface WaveGoldDividerProps {
  className?: string;
  flip?: boolean;
  dark?: boolean;
}

const WaveGoldDivider = ({ className = '', flip = false, dark = false }: WaveGoldDividerProps) => {
  const fillColor = dark ? 'hsl(220, 30%, 8%)' : 'hsl(0, 0%, 100%)';
  const gradientFrom = dark ? '#C9A351' : '#C9A351';
  const gradientTo = dark ? '#D4AF37' : '#B8860B';

  return (
    <div className={`relative w-full overflow-hidden ${flip ? 'rotate-180' : ''} ${className}`}>
      <svg
        viewBox="0 0 1440 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="w-[200%] animate-wave"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={gradientFrom} stopOpacity="0.3" />
            <stop offset="50%" stopColor={gradientTo} stopOpacity="0.5" />
            <stop offset="100%" stopColor={gradientFrom} stopOpacity="0.3" />
          </linearGradient>
        </defs>
        <path
          d="M0,60 C360,120 720,0 1080,60 C1440,120 1800,0 2160,60 C2520,120 2880,0 3240,60 L3240,120 L0,120 Z"
          fill="url(#waveGradient)"
        />
        <path
          d="M0,80 C360,120 720,40 1080,80 C1440,120 1800,40 2160,80 C2520,120 2880,40 3240,80 L3240,120 L0,120 Z"
          fill={fillColor}
        />
      </svg>
    </div>
  );
};

export default WaveGoldDivider;
